import { ArrowUpRight, ArrowRight, Mail, MapPin, Code2, Cloud, Layers, GraduationCap, FileDown, Sparkles, BriefcaseBusiness, Compass } from 'lucide-react';

const Github = () => <img className="social-logo" src="/images/skills/github.svg" alt="" />;
const Linkedin = () => <img className="social-logo" src="/images/skills/linkedin.svg" alt="" />;

const logos = {
  HTML: 'html5', CSS: 'css3', JavaScript: 'javascript', 'React.js': 'react',
  'Tailwind CSS': 'tailwindcss', Bootstrap: 'bootstrap', PHP: 'php', Laravel: 'laravel',
  'Node.js': 'nodejs', Express: 'express', MySQL: 'mysql', 'Oracle Database': 'oracle',
  Firebase: 'firebase', Flutter: 'flutter', Dart: 'dart', AWS: 'amazonwebservices',
  Cloudflare: 'cloudflare', Docker: 'docker', Git: 'git', GitHub: 'github',
  'VS Code': 'vscode', Postman: 'postman'
};

export default function BentoHome({ projects, stackGroups, navigateTo, playHoverSound, soundToggle }) {
  return (
    <main className="bento-root">
      <div className="bento-wrap">
        <div className="bento-grid">
          <section className="bento-tile profile-tile" onMouseEnter={playHoverSound}>
            <div className="profile-intro">
              <div className="bento-portrait" tabIndex="0" aria-label="Portrait of Jum'an Mama">
                <img className="bento-real" src="/images/juman.jpg" alt="Jum'an Mama" />
                <img className="bento-cartoon" src="/images/cartoon.png" alt="Cartoon portrait of Jum'an Mama" />
              </div>
              <div className="profile-name">
                <span className="available-badge"><span className="status-dot" />Open to internships</span>
                <p className="bento-eyebrow">HELLO, I'M</p>
                <h1>Jum&apos;an S. Mama<span>.</span></h1>
                <p>Full-stack developer <span className="muted">&</span> cloud enthusiast</p>
              </div>
            </div>
            <p className="profile-statement">Thoughtful code.<br /><span>Real-world possibilities.</span></p>
            <div className="profile-details">
              <span><MapPin />Manila, Philippines</span>
              <span><Code2 />Full-stack development</span>
              <span><Cloud />Cloud & DevOps</span>
            </div>
            <div className="profile-socials">
              <a href="https://github.com/Juman-Shinobi" target="_blank" rel="noreferrer"><Github />GitHub<ArrowUpRight /></a>
              <a href="https://www.linkedin.com/in/jum%E2%80%99an-mama-2469b3175/" target="_blank" rel="noreferrer"><Linkedin />LinkedIn<ArrowUpRight /></a>
              <a href="mailto:jumanmama2@gmail.com"><Mail />Email<ArrowUpRight /></a>
            </div>
          </section>

          <section className="bento-tile tools-tile" id="stack" onMouseEnter={playHoverSound}>
            <p className="tile-kicker"><Layers />My toolkit</p>
            <h2>The stack behind{' '}<br />the work.</h2>
            <div className="bento-stack">
              {stackGroups.map(({ title, icon: Icon, items }) => (
                <div className="bento-stack-group" key={title}>
                  <h3>{title}</h3>
                  <div className="skill-grid">
                    {items.map((item) => (
                      <span className="skill-item" key={item} title={item}>
                        {logos[item] ? <img src={`/images/skills/${logos[item]}.svg`} alt="" /> : <Icon aria-hidden="true" />}
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="bento-tile contact-tile" id="contact" onMouseEnter={playHoverSound}>
            <span className="tile-symbol"><Sparkles /></span>
            <p className="tile-kicker">Good things start with a hello</p>
            <h2>Let&apos;s work<br />together.</h2>
            <a className="cream-button" href="mailto:jumanmama2@gmail.com">Let&apos;s talk <ArrowUpRight /></a>
            <a className="contact-email" href="mailto:jumanmama2@gmail.com">jumanmama2@gmail.com</a>
          </section>

          <section className="bento-tile about-tile" onMouseEnter={playHoverSound}>
            <p className="tile-kicker"><Compass />The person behind the code</p>
            <h2>A builder.<br />A problem solver.</h2>
            <p>IT student at the University of Santo Tomas, bringing ideas to life through full-stack development, quality assurance, and project leadership.</p>
            <p>I enjoy connecting the details: from understanding a requirement to building, testing, and deploying something people can use.</p>
            <div className="about-bottom"><span className="status-dot" />Always learning. Always building.</div>
          </section>

          <section className="bento-tile education-tile" onMouseEnter={playHoverSound}>
            <p className="tile-kicker"><GraduationCap />Education & certifications</p>
            <h2>University of<br />Santo Tomas</h2>
            <p>BS in Information Technology</p>
            <span className="education-date">2022 — present</span>
            <ul>
              <li>CompTIA IT Fundamentals (ITF+)</li>
              <li>CCNA: Introduction to Networks</li>
              <li>Cisco: Introduction to Modern AI</li>
            </ul>
            <a className="resume-link" href="/images/juman_mama-resume.pdf" target="_blank" rel="noreferrer"><FileDown />Download resume<ArrowUpRight /></a>
          </section>

          <section className="bento-tile work-tile" id="work" onMouseEnter={playHoverSound}>
            <header className="work-header">
              <div><p className="tile-kicker"><BriefcaseBusiness />Selected work</p><h2>Ideas, made real.</h2></div>
              <a href="/projects" onClick={(event) => navigateTo(event, 'projects')} className="work-all">View all projects <ArrowUpRight /></a>
            </header>
            <div className="bento-projects">
              {projects.map((project, index) => (
                <a className="bento-project" key={project.title} href="/projects" onClick={(event) => navigateTo(event, 'projects')}>
                  <div className="bento-project-image"><img src={project.image} alt={`${project.title} screenshot`} /><span>0{index + 1}</span></div>
                  <div className="bento-project-caption"><div><span>{project.tag}</span><h3>{project.title}</h3></div><ArrowUpRight /></div>
                </a>
              ))}
            </div>
            <div className="work-bottom"><span>Full-stack development · QA · Project leadership</span><ArrowRight /></div>
          </section>

          <section className="bento-tile now-tile" onMouseEnter={playHoverSound}>
            <p className="tile-kicker"><span className="status-dot" />In progress</p>
            <h2>What's next?</h2>
            <p>Coordinating USTCB DigiLib&apos;s production launch and deepening my React and AWS skills.</p>
            <div className="now-tags"><span>Project leadership</span><span>QA testing</span><span>Cloud deployment</span></div>
          </section>
        </div>
        <footer className="bento-footer"><span>© {new Date().getFullYear()} Jum&apos;an S. Mama</span><span>Built with care. Deployed on AWS.</span><a href="#contact">Have something in mind? <ArrowUpRight size={14} /></a></footer>
      </div>
      {soundToggle}
    </main>
  );
}
